
/**
 * @internal
 */
export class Locale {
    public static isRightToLeft: boolean;
    public static safeLeft: string;
    public static safeRight: string;
    public static language: string;
    public static numberRadix: string;
    public static lcid: number;

    /**
     * Sets the locale to be used by the app.
     * @param language - The language used to render the app.
     * @param lcid - The language lcid used to render the app.
     */
    public static invalidate(language?: string, lcid?: number): void {
        Locale.isRightToLeft = (window.document && document.documentElement.getAttribute('dir') === 'rtl');
        Locale.safeLeft = Locale.isRightToLeft ? 'right' : 'left';
        Locale.safeRight = Locale.isRightToLeft ? 'left' : 'right';

        // fallback language
        Locale.language = language || 'en-US';

        Locale.lcid = lcid || 1033;

        // set number radix
        Locale.numberRadix = (1.2).toLocaleString(Locale.language).replace(/\d+/g, '');
    }
}

Locale.invalidate();
